import { EyeIcon, EyeSlashIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useViewMode } from '@/context/view-mode.context';
import { isGentlyAIUser } from '@/utils/user';
import { useContext } from 'react';
import { AuthContext } from '@/context/auth.context';

export function ViewModeToggle() {
  const { currentUser } = useContext(AuthContext);
  const { viewMode, toggleViewMode } = useViewMode();

  // Only show toggle for actual admins
  if (!isGentlyAIUser(currentUser)) {
    return null;
  }

  const isAdminView = viewMode === 'admin';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleViewMode}
            className="h-8 w-8"
            aria-label={`Switch to ${isAdminView ? 'end-user' : 'admin'} view`}
          >
            {isAdminView ? (
              <EyeIcon className="h-4 w-4" />
            ) : (
              <EyeSlashIcon className="h-4 w-4" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>
            {isAdminView ? 'Switch to end-user view' : 'Switch to admin view'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
